module.exports = __webpack_public_path__ + "static/media/profile-photo.ab464fe0.jpg";